<template>
  <v-dialog v-model="dialog" max-width="800" persistent>
    <v-card>
      <v-card-title>
        <span class="headline">List Document</span>
      </v-card-title>
      <v-card-text>
        <v-row class="mb-3">
          <v-col cols="12"
            ><v-btn
              color="success"
              @click="download"
              class="mr-2"
              v-if="$rbac.can('DIALOG.export')"
            >
              <v-icon>
                mdi-download
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-data-table
          :headers="headers"
          :items="items"
          dense
          disable-pagination
          hide-default-footer
        >
          <template v-slot:item.no="{ index }">
            {{ index + 1 }}
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn
              small
              color="primary"
              @click="downloadSingle(item)"
              v-if="$rbac.can('DIALOG.export')"
            >
              <v-icon>
                mdi-download
              </v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" @click="close">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import fileDownload from "js-file-download";

export default {
  name: "dialog-document",
  props: {
    dialog: Boolean,
    items: Array,
    woIds: Array,
  },
  data() {
    return {
      headers: [
        {
          id: 1,
          text: "No",
          align: "center",
          sortable: false,
          value: "no",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 2,
          text: "File Name",
          value: "fileName",
          sortable: false,
          align: "center",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 2,
          text: "Action",
          value: "action",
          sortable: false,
          align: "center",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
      ],
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    async download() {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("settlementKasbon/downloadDocument", this.woIds)
        .then(response => {
          fileDownload(response.data, "document.zip");
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    async downloadSingle(item) {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("settlementKasbon/downloadSingleDocument", item.id)
        .then(response => {
          fileDownload(response.data, item.fileName);
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
  },
};
</script>

<style></style>
